import detail from './product/detail';
import zoomService from 'base_global/product/zoomService';
import quickViewPdp from 'base_global/product/quickViewPdp';
import turnToPdp from 'turnToCustom/turnToPdp';
import pagedesignerCustom from 'base_global/search/pagedesignerCustom';
import sizeGuide from 'base_global/product/sizeGuide';
import headerhelper from 'base_global/helpers/headerHelper';
var processInclude = require('base/util');

// eslint-disable-next-line no-undef
$(document).ready(function () {
    processInclude(headerhelper);
    processInclude(detail);
    processInclude(zoomService);
    processInclude(quickViewPdp);
    processInclude(turnToPdp);
    processInclude(pagedesignerCustom);
    processInclude(sizeGuide);
});